var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1 1.5V9.25H1.8V0.75C1.8 0.662422 1.83079 0.590331 1.86823 0.547135C1.90371 0.506192 1.93519 0.5 1.95 0.5H12.35C12.3648 0.5 12.3963 0.506193 12.4318 0.547135C12.4692 0.59033 12.5 0.662423 12.5 0.75V12.75C12.5 13.2354 12.3322 13.689 12.051 14.0135C11.7717 14.3358 11.4096 14.5 11.05 14.5H1.95C1.59041 14.5 1.22827 14.3358 0.948986 14.0135L0.579026 14.3342L0.948986 14.0135C0.667753 13.689 0.5 13.2354 0.5 12.75V11.75H9.9V12.75C9.9 13.0602 10.0062 13.3697 10.2125 13.6078C10.4208 13.8482 10.72 14 11.05 14C11.38 14 11.6791 13.8482 11.8875 13.6078C12.0938 13.3697 12.2 13.0602 12.2 12.75V1.5V1H11.7H2.6H2.1V1.5Z",
    fill: "#4F4F4F",
    stroke: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.67ff5dddbfec73a232b70ffbdea064d0.svg";
export { ForwardRef as ReactComponent };